import './ProgressBar.scss';

interface ProgressBarProps {
  completeSections: number;
  totalSections: number;
  className?: string;
}

function ProgressBar({ completeSections, totalSections, className = '' }: ProgressBarProps) {
  const percentage = Math.ceil((completeSections / totalSections) * 100);
  return (
    <div className={`progress-bar ${className}`}>
      <div className="flex justify-between mb-1">
        <span>{percentage}% complete</span>
        <span>
          {completeSections}/{totalSections}
        </span>
      </div>
      <progress className="progress w-full" value={completeSections} max={totalSections} />
    </div>
  );
}

export default ProgressBar;
